__turbopack_context__.v({
  "input": "Input-module__5jsJuW__input",
  "inputWrapper": "Input-module__5jsJuW__inputWrapper",
  "label": "Input-module__5jsJuW__label",
  "textarea": "Input-module__5jsJuW__textarea",
});
